import { render, staticRenderFns } from "./Journals.vue?vue&type=template&id=69339de9"
import script from "./Journals.vue?vue&type=script&lang=js"
export * from "./Journals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports